{
  "common": {
    "cancel": "Cancel",
    "live": "Live"
  },
  "glossary": {
    "busArrivals": "Arrivals",
    "passingRoutes": "Connectivity",
    "popOut": "Pop out",
    "seatsAvailable": "Seats available",
    "standingAvailable": "Standing available",
    "limitedStanding": "Limited standing",
    "arriving": "Arr",
    "arrivingMinutes": "{{count}}m",
    "arrivingMinutes_plural": "{{count}}m",
    "multiRouteMode": "Multi-route mode",
    "nRoutes": "{{count}} route",
    "nRoutes_plural": "{{count}} routes",
    "nStops": "{{count}} stop",
    "nStops_plural": "{{count}} stops",
    "nServices": "{{count}} service",
    "nServices_plural": "{{count}} services",
    "weekdaysShort": "WD",
    "weekdays": "Weekdays",
    "saturdaysShort": "SAT",
    "saturdays": "Saturdays",
    "sundaysPublicHolidaysShort": "SUN",
    "sundaysPublicHolidays": "Sunday & Public Holidays",
    "service": "Route",
    "firstBus": "First Trip",
    "lastBus": "Last Trip"
  },
  "app": {
    "name": "TransitRouter",
    "title": "$t(app.name) - Transit Routes Explorer",
    "shortDescription": "Transit Routes Explorer",
    "description": "Explore transit stops and routes across multiple cities on an interactive map."
  },
  "about": {
    "explore": "Let's explore"
  },
  "search": {
    "placeholder": "Search for route or stop",
    "geolocate": "Use current location"
  },
  "service": {
    "title": "Transit service {{serviceNumber}}: {{serviceName}} - $t(app.name)",
    "titleMultiple": "Transit services: {{serviceNumbersNames}} - $t(app.name)",
    "oppositeLegend": "Stops with opposite direction of services"
  },
  "stop": {
    "title": "Stop {{stopNumber}}: {{stopName}} - $t(app.name)",
    "titleRoutes": "Routes passing stop {{stopNumber}}: {{stopName}} - $t(app.name)",
    "firstLastBus": "Timetable",
    "diagramBus": "Stop route diagram",
    "multipleDirectionsWarning": "Some services serve multiple directions. Open \"Arrivals\" to see more details.",
    "liveBusTrack": "{{count}} trips now on track",
    "liveBusTrack_plural": "{{count}} trips now on track."
  },
  "passingRoutes": {
    "passingRoutes": "{{count}} passing route",
    "passingRoutes_plural": "{{count}} passing routes"
  },
  "multiRoute": {
    "addRoute": "Add another route",
    "showingServices": "Showing {{count}} service",
    "showingServices_plural": "Showing {{count}} services",
    "intersectingStops": "{{count}} intersecting stop",
    "intersectingStops_plural": "{{count}} intersecting stops"
  },
  "arrivals": {
    "invalidBusStopCode": "Invalid stop code.",
    "preHeading": "Arrivals",
    "title": "Arrivals",
    "titleStop": "Arrivals for {{stopNumber}} - {{stopName}}",
    "multipleVisitsLegend": "1st or 2nd visit. Stops here twice, going in different directions. Check destination before boarding.",
    "wheelchairDisclaimer": "<0/> All public transit in revenue service are <2>wheelchair-accessible</2>. The ones that are not accesssible will be marked with this icon <4/>"
  },
  "timetable": {
    "title": "Timetable for {{stopNumber}}: {{stopName}}",
    "busStopCodeNotFound": "Stop code not found.",
    "preHeading": "Timetable",
    "tripsLabel": "trips",
    "backToStop": "Back to stop",
    "backToTrips": "Back to trips",
    "loading": "Loading...",
    "noSchedule": "No schedule data available"
  },
  "vehicle": {
    "title": "Vehicle {{vehicleNumber}} - $t(app.name)",
    "notActive": "Vehicle not currently active",
    "loadFailed": "Could not load vehicle",
    "estimatedPosition": "Position estimated from stop times",
    "now": "Now",
    "minutes": "{{count}} min",
    "minutesAgo": "{{count}} min ago"
  }
}
